const GetHolds = `
  query Query($count: Int, $cursor: String) {
    adHocHolds(first: $count, after: $cursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          description
          startTime
          endTime
          sender {
            id
            name
            description
          }
          receiver {
            id
            name
            description
          }
          dataType {
            id
            name
            description
          }        
        }
      }
    }
  }
`

module.exports = {
  GetHolds,
}
